module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/great-9a74d3331fdc23a1005b99a1d86ac883.png";